<template>
  <div id="login">
    <div class="row h-100 justify-content-center align-items-center">
      <form class="login-form forgot-password form" action="map.php" method="post">
        <h3 class="text-center brand">
          <img src="/frontend/img/logo-icon.svg" />
        </h3>
        <div v-if="loginReason" class="alert alert-warning text-center login-reason" role="alert">
          {{ loginReason }}
        </div>
        <div class="form-group">
          <input
            type="text"
            v-model="state.user.username"
            name="email"
            id="username"
            class="form-control"
            :placeholder="i18n.app.common.username"
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            v-model="state.user.password"
            name="password"
            id="password"
            class="form-control"
            :placeholder="i18n.app.common.password"
          />
        </div>
        <div class="text-right forget-password">
          <a href="/forgot-password">{{ i18n.app.components.login.forgot_password }}</a>
        </div>
        <div class="form-group text-center">
          <button
            :disabled="state.loading"
            @click.prevent="onLoginPress"
            class="btn btn-default"
            :class="state.loading && 'load-spinner'"
          >
            <span>{{ i18n.app.components.login.login }}</span>
          </button>
        </div>
        <div class="text-center footer-brand">
          <img src="/frontend/img/logo-grey.svg" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dialogMixin from "@/mixins/dialog.mixin";

export default {
  data() {
    return {
      state: {
        loading: false,
        user: {
          username: "",
          password: ""
        }
      }
    };
  },
  mixins: [dialogMixin],
  computed: {
    /**
     * Explains a forced logout on the login screen (RR-330).
     *
     * Guest routes are mounted outside DefaultLayout, so the required-action
     * banner cannot reach them; the reason travels as ?reason=<key> instead and
     * resolves against notices.login_reasons. An unknown or absent key renders
     * nothing rather than throwing.
     */
    loginReason() {
      const reason = this.$route.query.reason;

      if (!reason) {
        return "";
      }

      return this.i18n?.notices?.login_reasons?.[reason] ?? "";
    }
  },
  methods: {
    onLoginPress() {
      this.state.loading = true;
      this._login({
        user: {
          ...this.state.user
        }
      })
        .then(state => {
          this._fetchUser().then(user => {
            if(user?.has_frontend_access){
              this.$router.push({ name: "home" });
            } else {
              this.$router.push({ name: "account" });
            }
          });
        })
        .catch(e => {
          this.showSimpleMessage(i18n.app.login.messages.incorrect_credentials);
        })
        .finally(() => (this.state.loading = false));
    },
    ...mapActions({
      _login: "login",
      _fetchUser: "fetchUser",
    })
  }
};
</script>
